// extracted by mini-css-extract-plugin
export default {"wrapper":"Service_wrapper__i4MiW","container":"Service_container__OvEoa"};